import App from './App.svelte'
import { config } from "./Store/ConfigStore"
import { state } from "./Store/StateStore"


// load config from wordpress
config.fromWordpress( culConfig )
const target = document.querySelector( culConfig.target )
const guarded = document.querySelectorAll( culConfig.guard_selector )

if ( culConfig.debug ) {
	console.log( window.culConfig )
	console.log( { guarded } )
	console.log( { target } )
}

// create the app
const app = new App( {
	target,
	props: {
		guarded,
	}
} )

export default app
